import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./returnInquiryConfirmationPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";

function ReturnInquiryConfirmationPopup({ onClose }: IPopupWithoutProps) {
  return (
    <article className={popupStyles.popup}>
      <h2 className={popupStyles.popup__title}>
        {t("RETURN_INQUIRY_CONFIRMATION_TITLE")}      </h2>
      <img
        src={doctor}
        alt={t("IMAGE_ALT_VENCHY_DOCTOR")}
        className={popupStyles.popup__img}
      />
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >
        {t("RETURN_INQUIRY_CONFIRMATION_BUTTON")}
      </button>
    </article>
  );
}

export default ReturnInquiryConfirmationPopup;
